const state = {
    sqft: 2450,
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
    setSqft(state, sqft) {
        state.sqft = sqft
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}